import React, { memo } from "react";
import spinner from "../../Assets/Image/spinner.gif";
import dotSpinner from "../../Assets/Image/dot-loader.gif";

const Loader = ({ type, className, width }) => {
  return (
    <div className={`${className} text-center`}>
      <img src={type === 1 ? dotSpinner : spinner} width={width} alt="loader" />
    </div>
  );
};

export default memo(Loader);
